import * as $ from 'jquery';
import 'owl.carousel/dist/owl.carousel';
import '@fancyapps/fancybox';

export function setupSideStudentPerformance() {
    $(document).ready(function () {
        $('.owl-student').owlCarousel({
            loop: false,
            margin: 16,
            nav: false,
            dots: true,
            responsive: {
                0: {
                    items: 1
                },
                426: {
                    items: 2
                },
                1025: {
                    items: 2
                }
            }
        });
    });
}

